import BiografiaGrid from "./BiografiaGrid";

function Biografia() {
  return (
    <main className="biografia-container container" >
      <BiografiaGrid />
    </main>
  );
}

export default Biografia;
